import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { connect } from 'react-redux';
import { noop } from '@lux/helpers';
import {
  authActions,
  planActions,
  productActions,
  rootActions
} from '@detox/actions';
import '../../../fragments/rrp-product-detail';
import '../../../fragments/aem-components';
import { PhoneDetails } from './phoneDetails';

export const RRPPhoneTemplate = props => {
  return <PhoneDetails {...props} />;
};

RRPPhoneTemplate.defaultProps = {
  exclusiveValidation: {
    show: true
  },
  getAuthToken: noop,
  setSelectedProduct: noop,
  setSelectedPlan: noop,
  setUserSelection: noop,
  resetByKeys: noop
};

RRPPhoneTemplate.propTypes = {
  data: PropTypes.object,
  exclusiveValidation: PropTypes.shape({
    show: PropTypes.bool
  }),
  getAuthToken: PropTypes.func,
  sessionToken: PropTypes.string,
  setSelectedProduct: PropTypes.func,
  setSelectedPlan: PropTypes.func,
  selectedProduct: PropTypes.object,
  selectedPlan: PropTypes.object,
  productOrder: PropTypes.object,
  productOrderIsLoading: PropTypes.bool,
  resetByKeys: PropTypes.func,
  cisPlanRates: PropTypes.arrayOf(
    PropTypes.shape({
      planID: PropTypes.string,
      discountedPrice: PropTypes.string
    })
  )
};

/* istanbul ignore next */
const mapStateToProps = state => {
  const { auth, order, plan, product, setting, user } = state;

  return {
    selectedProduct: product.selectedProduct,
    selectedPlan: plan.selectedPlan,
    auth: auth,
    sessionToken: auth.sessionToken,
    productOrder: order.productOrder,
    productOrderIsLoading: order.productOrderIsLoading,
    cisPlanRates: user.cis.information && user.cis.information.rates,
    exclusiveValidation: setting.exclusiveValidation
  };
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => {
  const { setSelectedProduct } = productActions;
  const { setSelectedPlan } = planActions;
  const { getAuthToken, resetWorryFree } = authActions;
  const { resetByKeys } = rootActions;

  return {
    getAuthToken: options => dispatch(getAuthToken(options)),
    hideExclusiveValidation: () =>
      dispatch({
        type: 'EXCLUSIVE_VALIDATION_HIDE'
      }),
    setUserSelection: selection =>
      dispatch({
        type: 'SET_USER_SELECTION',
        payload: selection
      }),
    setSelectedProduct: product => dispatch(setSelectedProduct(product)),
    setSelectedPlan: plan => dispatch(setSelectedPlan(plan)),
    resetByKeys: keys => dispatch(resetByKeys(keys)),
    resetWorryFree: () => dispatch(resetWorryFree())
  };
};

const ConnectedRRPPhoneTemplate = connect(
  mapStateToProps,
  mapDispatchToProps
)(RRPPhoneTemplate);

export default ConnectedRRPPhoneTemplate;

export const query = graphql`
  query RRPPhoneByIndex($id: String) {
    rrpProduct(id: { eq: $id }) {
      ...RRPProductDetailFragment
    }

    allVariableConfig {
      edges {
        node {
          name
          value
        }
      }
    }
    allAemPages(filter: { pageUrl: { eq: "/eshop/admin.xjson" } }) {
      edges {
        node {
          title
          components {
            ...AemComponentsFragment
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;
